import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { FleetSurveyRating } from '@shared-features/enums/fleet-survey-rating.enum';
import { IFleetSurveyResponseHeader } from '@shared-features/interfaces/fleet-survey-response-header.interface';
import { FleetSurveyAction } from '@shared-features/enums/fleet-survey-action.enum';
import { FleetSurveyService } from '@shared-features/services/fleet-survey.service';
import { IFleetSurveyPayload } from '@shared-features/interfaces/fleet-survey-payload.interface';

@Component({
  selector: 'app-fleet-survey-dialog',
  templateUrl: './fleet-survey-dialog.component.html',
  styleUrls: ['./fleet-survey-dialog.component.scss'],
})
export class FleetSurveyDialogComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  fleetSurveyRating = FleetSurveyRating;

  constructor(
    private dialogRef: MatDialogRef<FleetSurveyDialogComponent>,
    private fb: FormBuilder,
    private fleetSurveyService: FleetSurveyService,
    @Inject(MAT_DIALOG_DATA)
    public data: IFleetSurveyResponseHeader
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.dialogRef.afterClosed().subscribe((data) => {
      if (!data?.submitted) {
        this.ignoreFleetSurveyDialog();
      }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      rating: [null, Validators.required],
      notes: [''],
    });
  }

  selectRating(rate: FleetSurveyRating): void {
    this.form.controls.rating.setValue(rate);
  }

  submitFleetSurvey(): void {
    const { valid, value } = this.form;
    if (!valid) return;
    const payload: IFleetSurveyPayload = {
      ...value,
      threshold: this.data.threshold ?? 0,
      action: FleetSurveyAction.Submitted,
    };
    this.load(this.fleetSurveyService.addFleetSurvey(payload), { isLoadingTransparent: true }).subscribe(() => {
      this.dialogRef.close({ submitted: true });
    });
  }

  ignoreFleetSurveyDialog(): void {
    const payload: IFleetSurveyPayload = {
      threshold: this.data.threshold ?? 0,
      action: FleetSurveyAction.Ignored,
    };
    this.load(this.fleetSurveyService.addFleetSurvey(payload), { isLoadingTransparent: true }).subscribe(() => {});
  }
}
